<template>
    <div v-loading.fullscreen.lock="loading">
        <el-form :model="form" ref="formDaftar" :rules="rules" :inline="false" size="small" >
            <el-form-item label="Pakej" prop="pakej" v-if="!isLoggedIn">
                    <el-radio-group v-model="form.pakej" size="small">
                        <el-radio-button label="m">1 BULAN<br/>(RM19)</el-radio-button>
                        <el-radio-button label="y">1 TAHUN<br/>(RM180)</el-radio-button>
                        <el-radio-button label="5y">5 TAHUN<br/>(RM600)</el-radio-button>
                    </el-radio-group>
            </el-form-item>
            <el-form-item label="Jenis Dealer" prop="jenis">
                    <el-radio-group v-model="form.jenis" size="small">
                        <el-radio-button label="d">Dealer</el-radio-button>
                        <el-radio-button label="pd">Priority Dealer</el-radio-button>
                        <el-radio-button label="md">Master Dealer</el-radio-button>
                    </el-radio-group>
            </el-form-item>
            <el-form-item label="Tarikh Tamat Langganan" v-if="isLoggedIn">
                <template>
                    <div style="text-align: left;">                        
                        <el-tag :type="isBefore ? 'success' : 'danger'" size="normal"  effect="dark" >{{ form.tarikh_tamat | tarikh }}</el-tag>                        
                    </div>
                </template>
            </el-form-item>

            <el-form-item label="Nama Penuh" prop="fullname">
                <el-input v-model="form.fullname" clearable maxlength="100"></el-input>
            </el-form-item>

            <el-form-item label="Nama Nick" prop="nick">
                <el-input v-model="form.nick" clearable maxlength="100" @change='chgnick'></el-input>
            </el-form-item>

            <el-form-item label="Web ID (huruf dan nombor sahaja)" prop="webid">
                <el-input v-model="form.webid" placeholder="webidanda" maxlength="50" @input="idcheck" :disabled="isLoggedIn" style="text-align: left !important;">
                    <template slot="prepend">publicgold.me/</template>
                      <i
                            :class="(this.$store.getters.stateAvailable == 'available' ? 'el-icon-check' : 'el-icon-close') + ' el-input__icon'"
                            :style="'color: ' + (this.$store.getters.stateAvailable == 'available' ? '#67C23A' : '#F56C6C')"
                            slot="suffix">
                        </i>
                </el-input>
            </el-form-item>

            <el-form-item label="Password" size="normal" prop="password">
                <el-input v-model="form.password"  clearable show-password></el-input>                  
            </el-form-item>

            <el-form-item label="Retype Password" size="normal" prop="confirmpassword">
                <el-input v-model="form.confirmpassword"  clearable show-password></el-input>                
            </el-form-item>

            <el-form-item label="PG Code" prop="pgcode">
                <el-input v-model="form.pgcode" clearable maxlength="20" @input="uppercase"></el-input>
            </el-form-item>

            <el-form-item label="Telefon" prop="tel">
                <el-input v-model="form.tel" clearable maxlength="14">
                    <template slot="prepend"><font-awesome-icon :icon="['fab', 'whatsapp']" size="lg" :style="{color: '#25d366'}"></font-awesome-icon></template>
                </el-input>
            </el-form-item>

            <el-form-item label="Email" prop="emel">
                <el-input v-model="form.emel" clearable maxlength="50" placeholder="ahmad@gmail.com"></el-input>
            </el-form-item>

            <el-form-item label="Foto" size="normal" style="text-align: left;" prop="foto">
                <el-link type="primary" @click="show = !show" :underline="false">- Pilih foto -</el-link>
                <br/>
                <div v-if="(form.webid && !imgDataUrl) || !!imgDataUrl">                        
                    <div class="hidden-md-and-down">
                        <el-avatar icon="el-icon-user-solid" v-if="!isLoggedIn && imgDataUrl" :src="imgDataUrl" :size="389"></el-avatar>
                        <el-avatar icon="el-icon-user-solid" v-if="isLoggedIn" :src="imgDataUrl || ($webURL + '/assets/img/dealers/'+form.webid+'.jpg?v='+form.version)" :size="389"></el-avatar>
                    </div>
                    <div class="hidden-lg-and-up">
                        <el-avatar icon="el-icon-user-solid" v-if="!isLoggedIn && imgDataUrl" :src="imgDataUrl" :size="250"></el-avatar>
                        <el-avatar icon="el-icon-user-solid" v-if="isLoggedIn" :src="imgDataUrl || ($webURL + '/assets/img/dealers/'+form.webid+'.jpg?v='+form.version)" :size="250"></el-avatar>
                    </div>
                </div>
            </el-form-item>

            <el-form-item label="Ayat Intro" prop="ayatintro">
                <el-input type="textarea" :rows="4" v-model="form.ayatintro" clearable maxlength="500" show-word-limit></el-input>
            </el-form-item>

            <el-form-item label="Ayat Whatsapp" prop="ayatwhatsapp">
                <el-input type="textarea" :rows="3" v-model="form.ayatwhatsapp" clearable maxlength="100" show-word-limit :placeholder="'Salam/Hi '+(form.nick || '')+'. Boleh ajar saya beli emas?'"></el-input>
            </el-form-item>

            <el-form-item label="Ayat CTA" prop="ayatCTA">
                <el-input v-model="form.ayatCTA" clearable maxlength="30" placeholder="Bantu Saya Simpan Emas"></el-input>
            </el-form-item>
            
            <el-divider content-position="left">Media Sosial (Optional)</el-divider>

            <el-form-item label="Website" prop="website">
                <el-input v-model="form.website" clearable maxlength="100" placeholder="websiteanda.com">
                    <template slot="prepend">https://</template>
                </el-input>
            </el-form-item>

            <el-form-item label="" size="normal" prop="fb">
                <el-input v-model="form.fb" placeholder="ID facebook" size="normal" clearable v-popover:fbtips>
                    <template slot="prepend"><font-awesome-icon :icon="['fab', 'facebook']" size="lg" :style="{color: '#3b5998'}"></font-awesome-icon></template>
                </el-input>
                <el-popover
                    ref="fbtips"
                    placement="top-start"
                    width="170"
                    trigger="focus"
                    content="Contoh facebook.com/ahmad, isi ahmad sahaja">
                </el-popover>
            </el-form-item>

            <el-form-item label="" size="normal" prop="ig">
                <el-input v-model="form.ig" placeholder="ID instagram" size="normal" clearable>
                    <template slot="prepend"><font-awesome-icon :icon="['fab', 'instagram']" size="lg" :style="{color: '#c32aa3'}"></font-awesome-icon></template>
                </el-input>
            </el-form-item>
            
            <el-form-item label="" size="normal" prop="tw">
                <el-input v-model="form.tw" placeholder="ID twitter" size="normal" clearable>
                    <template slot="prepend"><font-awesome-icon :icon="['fab', 'twitter']" size="lg" :style="{color: '#1da1f2'}"></font-awesome-icon></template>
                </el-input>
            </el-form-item>
            
            <el-form-item label="" size="normal" prop="yt">
                <el-input v-model="form.yt" placeholder="ID youtube" size="normal" clearable>
                    <template slot="prepend"><font-awesome-icon :icon="['fab', 'youtube']" size="lg" :style="{color: '#ff0000'}"></font-awesome-icon></template>
                </el-input>
            </el-form-item>
            
            <el-form-item label="" size="normal"  prop="tg">
                <el-input v-model="form.tg" placeholder="ID telegram" size="normal" clearable>
                    <template slot="prepend"><font-awesome-icon :icon="['fab', 'telegram']" size="lg" :style="{color: '#0088cc'}"></font-awesome-icon></template>
                </el-input>
            </el-form-item>
            
            <el-form-item label="" size="normal" prop="tt">
                <el-input v-model="form.tt" placeholder="ID tiktok" size="normal" clearable>
                    <template slot="prepend"><font-awesome-icon :icon="['fab', 'tiktok']" size="lg" :style="{color: '#010101'}"></font-awesome-icon></template>
                </el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="btnDaftar">{{ !isLoggedIn ? 'Daftar' : 'Kemaskini'}}</el-button>
            </el-form-item>
        </el-form>

            <my-upload field="img"
                        v-model="show"
                        :width="487"
                        :height="487"
                        @crop-success="cropSuccess"
                        :headers="headers"
                        img-format="png"
                        :noSquare="true"
                        :langExt="langExt">
            </my-upload>
        
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Vue from 'vue'
import { mapActions } from "vuex";
import 'element-ui/lib/theme-chalk/display.css';
export default {
    name: 'Registration',
    data() {
        return {         
            loading: false,   
            form: {
                pgcode: '',
                tel: '6',
                affiliate: '',
                ayatintro: 'Saya merupakan dealer Public Gold. Saya akan membantu anda mula menyimpan emas. Hubungi saya untuk bimbingan.',
                ayatwhatsapp: '',
                ayatCTA: 'Bantu Saya Simpan Emas'
            },
            rules:{
                pakej: {
                    required: true,
                    message: "Sila pilih pakej anda"
                },
                fullname: {
                    required: true,
                    type: 'string',
                    message: "Sila lengkapkan nama penuh anda"
                },
                nick: {
                    required: true,
                    type: 'string',
                    message: "Sila lengkapkan nickname anda"
                },
                webid: {
                    required: true,
                    type: 'string',
                    message: "Sila lengkapkan Web ID anda (alfanumerik sahaja)",
                    pattern: /^[A-Za-z0-9]+$/
                },
                password: {
                    required: true,
                    type: 'string',
                    message: "Sila isi katalaluan anda"
                },
                confirmpassword: {
                    required: true,
                    type: 'string',
                    message: "Sila isi katalaluan anda dan sama seperti katalaluan di atas"
                },
                pgcode: {
                    required: true,
                    type: 'string',
                    message: "Sila lengkapkan PG Code anda"
                },
                tel: {
                    required: true,
                    type: 'string',
                    message: "Sila lengkapkan No Telefon anda"
                },
                emel: {
                    required: true,
                    type: 'email',
                    message: "Sila lengkapkan emel mengikut format emel yang betul" 
                },
                foto: {
                    required: true,
                    message: 'Foto anda diperlukan'
                },
                fb: {                    
                    message: "Sila lengkapkan butiran ID sahaja tanpa http, :, /",
                    pattern: /^[A-Za-z0-9.\-/+_]+$/
                },
                ig: {                    
                    message: "Sila lengkapkan butiran ID sahaja tanpa http, :, /",
                    pattern: /^[A-Za-z0-9.\-/+_]+$/
                },
                yt: {                    
                    message: "Sila lengkapkan butiran ID sahaja tanpa http, :, /",
                    pattern: /^[A-Za-z0-9.\-/+_]+$/
                },
                tw: {                    
                    message: "Sila lengkapkan butiran ID sahaja tanpa http, :, /",
                    pattern: /^[A-Za-z0-9.\-/+_]+$/
                },
                tg: {                    
                    message: "Sila lengkapkan butiran ID sahaja tanpa http, :, /",
                    pattern: /^[A-Za-z0-9.\-/+_]+$/
                },
                tt: {                    
                    message: "Sila lengkapkan butiran ID sahaja tanpa http, :, /",
                    pattern: /^[A-Za-z0-9.\-/+_]+$/
                }
            },
            show: false,
            params: {
                token: '123456798',
                name: 'avatar'
            },
            headers: {
                smail: '*_~'
            },
            imgDataUrl: '', // the datebase64 url of created image
            langExt: {
                hint: 'Klik untuk pilih foto anda',
                preview: 'Preview',
                btn: {
                    off: 'Batal',
                    close: 'Tutup',
                    back: 'Kembali',
                    save: 'Simpan'
                },
                error: {
                    onlyImg: 'Imej sahaja',
                    outOfSize: 'Image exceeds size limit: ',
                    lowestPx: 'Image\'s size is too low. Expected at least: '
                }
            }
        }
    },
    computed: {
        isLoggedIn: function () { return this.$store.getters.isLoggedIn },
        stateWebID: function () { return this.$store.getters.stateWebID },
        isBefore: function() { return moment().isBefore(this.form.tarikh_tamat) }
    },
    methods: {
        ...mapActions(['Register','Update']),
        uppercase(x) {
            this.form.pgcode = x.toUpperCase()
        },
        cropSuccess(imgDataUrl){
            this.imgDataUrl = imgDataUrl;
            this.form.foto = imgDataUrl.replace('data:image/png;base64,','');
            console.log(this.form);
            this.show = false;
        },
        btnDaftar() {
            var _this = this;
            this.$refs['formDaftar'].validate((valid) => {
                if (valid && (this.$store.getters.stateAvailable == 'available' || this.isLoggedIn)) {
                    try {
                        this.loading = true
                        
                        if(this.form.password != this.form.confirmpassword) {
                                                    
                            this.$message({
                                showClose: true,
                                message: 'Sila pastikan kedua-dua katalaluan adalah sama',
                                type: 'error'
                            });
                        }
                        
                        else {                           
                            delete this.form.confirmpassword
                            
                            if(!this.isLoggedIn) {
                                this.Register(this.form)
                                .then( resp => {                                
                                    this.$message({
                                        showClose: true,
                                        message: resp.data.status,
                                        type: 'success',
                                        onClose: function() {
                                            _this.$router.push('/login');
                                        }
                                    });                                    
                                    this.loading = false
                                })
                                .catch( () => {
                                    this.loading = false
                                })
                            }
                            else {
                                this.Update(this.form)
                                .then( resp => {                                
                                    this.$message({
                                        showClose: true,
                                        message: resp.data.status,
                                        type: 'success'
                                    });                 
                                    this.loading = false
                                })
                                .catch( () => {
                                    this.loading = false  
                                })
                            } 
                        }
                    } catch (error) {                           
                            this.$message({
                                showClose: true,
                                message: error,
                                type: 'danger'
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        idcheck(v) {
            this.$store.dispatch('idcheck',v)
        },
        chgnick(v) {
            if(!this.form.ayatwhatsapp) {
                this.form.ayatwhatsapp = 'Salam/Hi ' + v + '. Boleh ajar saya beli emas?'
            }
        }
    },
    created() {
        if(this.isLoggedIn) {
            this.loading = true
            axios('profile')
            .then(resp => {
                this.form = resp.data.user
                Vue.set(this.form,'confirmpassword', this.form.password);
                this.loading = false
            })
            .catch((err) => {
                console.log(err, 'Error webID');
                this.loading = false
            })
        }
        
        else {
            // eslint-disable-next-line no-undef
            this.form.affiliate = $cookies.get('affiliate')
        }
    },
    filters: {
        tarikh(x) {
            return moment(x,'yyyy-MM-DD hh:mm:ss').format('DD/MM/yyyy')
        }
    }
}
</script>
